/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { Box, GenericLoader, Typography } from "../../../../Components";
import { useDispatch, useSelector } from "react-redux";
import { getAllLookupList } from "../../../../Redux/actions";

const Alcohol = ({ values, setFieldValue }) => {
  let dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllLookupList("WeeklyAlcoholIntake"));
  }, []);

  const data = useSelector((state) => state.patientProfile);

  return (
    <div>
      {" "}
      <Typography fontSize="1rem" fontWeight="400" color="#9370DB">
        LIFE PATTERNS & HABITS
      </Typography>
      <Typography fontSize="1.25rem" fontWeight="500" className="my-3">
        Weekly Alcohol Intake
      </Typography>
      <Typography fontSize="0.8rem" fontWeight="300">
        A standard drink is equivalent to a regular can or bottle of beer, a
        typical serving (glass) of wine, or a shot of distilled spirits.
      </Typography>
      {data?.GET_LOOKUP_LIST_LOADING ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "150px" }}
        >
          <GenericLoader />
        </div>
      ) : (
        data?.GET_LOOKUP_LIST?.map((option, idx) => (
          <>
            <Box
              className="p-3 my-3 cursor-pointer option-wrapper"
              onClick={() => setFieldValue("alcoholId", option?.lookupId)}
              height="100%"
              width="100%"
              borderRadius="0.5rem"
              background={values?.alcoholId === option?.lookupId && "#9370DB"}
              border={
                values?.alcoholId === option?.lookupId && "1px solid #9370DB"
              }
            >
              <Typography
                fontSize=".9rem"
                fontWeight={values?.alcoholId === option?.lookupId && "500"}
                className="heading"
                color={values?.alcoholId === option?.lookupId && "white"}
              >
                {option?.text}
              </Typography>
            </Box>
          </>
        ))
      )}
    </div>
  );
};

export default Alcohol;
